/**
 * @generated SignedSource<<84dc5aea5b496fa1cb12196cb760af48>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableDetailsTabs_item$data = {
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly storyTelling: {
    readonly tabs: ReadonlyArray<{
      readonly tabTitle: string;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedStoryTellingTab_storyTellingTab">;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_item" | "PdpRespSharedSellerDetails_item">;
  readonly " $fragmentType": "PdpRespUnavailableDetailsTabs_item";
};
export type PdpRespUnavailableDetailsTabs_item$key = {
  readonly " $data"?: PdpRespUnavailableDetailsTabs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableDetailsTabs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableDetailsTabs_item",
  "selections": [
    {
      "alias": "storyTelling",
      "args": [
        {
          "kind": "Literal",
          "name": "shortTitles",
          "value": true
        }
      ],
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedStoryTellingTab_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "storyTellingModule(shortTitles:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSellerDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e3d6cf8f27e6064ab7b16358f32c7046";

export default node;
